const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: '720px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '0 16px 16px',
    marginTop:"32px"
  },

  title: {
    fontSize: '20px',
    fontWeight: 500,
    textAlign: 'center',
    marginBottom: theme.spacing(2),
  },
  subtitle: {
    fontSize: '16px',
    fontWeight: 400,
  },
})

export default styles
